export const pushToGTM = (eventName, data = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...data,
    });
  }
};
